import { FC, Fragment } from 'react'
import Link from 'next/link'

import NewslineCard from 'components/cards/newsline-card/newsline-card'
import NewWebinarCard from 'components/cards/new-webinar-card/new-webinar-card'
import Loader from 'components/parts/loader/loader'

import { INewslineCard } from 'constants/types/card.types'
import { originSubscribe, originFWebinar } from 'utils/analytics/webinars/webinar_future'

import styles from './search-page.module.scss'

interface IResults {
  articles: INewslineCard[]
  cutQueryWords?: string[]
  isLoading: boolean
  toggleSubscribe?: any
}

const ResultsWrapper: FC<IResults> = ({
  articles,
  isLoading,
  cutQueryWords,
  toggleSubscribe,
}: IResults) => {
  const handleToggle = (id: number, isSubscribed?: boolean) => (e: any) => {
    e.preventDefault()
    toggleSubscribe(id, isSubscribed)
  }

  return (
    <div className={styles.cardsWrapper}>
      {articles?.map((article, index) => {
        return (
          <Fragment key={article.materialType + article._id}>
            <Link
              className={styles.card}
              href={`/${article.materialType}/${article.linkTranslation || article.id}`}
            >
              {article.startDate > new Date() ? (
                <NewWebinarCard
                  {...article}
                  isLoaded={!isLoading}
                  handleToggle={handleToggle(article.id, article.isSubscribed)}
                  AData={{
                    originSub: originSubscribe.NOORIGIN,
                    originClick: originFWebinar.NOORIGIN,
                  }}
                />
              ) : (
                <NewslineCard {...article} cutQueryWords={cutQueryWords} withPreview={false} />
              )}
            </Link>
          </Fragment>
        )
      })}

      {isLoading && <Loader />}
    </div>
  )
}

export default ResultsWrapper
